import type { LucideIcon } from "lucide-react";

// Import icons from Lucide
import {
  Leaf,
  Utensils,
  Zap,
  Car,
  Beef,
  Coffee,
  Shrimp,
  Drumstick,
  Carrot,
  Nut,
  Fish,
  Egg,
  Milk,
  Banana,
  Apple,
  Citrus,
  Wheat,
  Wine,
  Grape,
  Beer,
  Plane,
  Motorbike,
  Bus,
  EvCharger,
  TrainFront,
  TramFront,
  Bike,
  Ship,
  Laptop,
  BatteryCharging,
  Refrigerator,
  Snowflake,
  Antenna,
  Printer,
  BoomBox,
  Heater,
  LampDesk,
  Disc,
  Monitor,
  PcCase,
  Tv,
  Gamepad2,
  WashingMachine,
  AirVent,
  Microwave,
  Wifi,
  Speaker,
  CookingPot,
} from "lucide-react";

// Dictionary
export const emissionsIcons: Record<string, LucideIcon> = {
  default: Leaf,
  Food: Utensils,
  Appliance: Zap,
  Travel: Car,

  "Beef (beef herd)": Beef,
  "Lamb & Mutton": Beef,
  "Beef (dairy herd)": Beef,
  Coffee,
  "Prawns (farmed)": Shrimp,
  Pork: Beef,
  Poultry: Drumstick,
  Fish,
  "Fish (wild catch)": Fish,
  Eggs: Egg,
  Milk,
  Groundnuts: Nut,
  Soymilk: Milk,
  Bananas: Banana,
  Apples: Apple,
  "Citrus Fruit": Citrus,
  "Root Vegetables": Carrot,
  Nuts: Nut,
  "Wheat & Rye (bread)": Wheat,
  Wine:Wine,
  "Berries & Grapes":Grape,
  Beer:Beer,

  "Domestic flight": Plane,
  "Short-haul flight (Economy class)": Plane,
  "Short-haul flight (Business class)": Plane,
  "Long-haul flight (Economy class)": Plane,
  "Long-haul flight (Business class)": Plane,
  "Long-haul flight (First class)": Plane,
  Motorbike,
  "Bus (average)": Bus,
  "Bus (city)": Bus,
  "Plug-in hybrid car": EvCharger,
  "Electric car": EvCharger,
  "National rail": TrainFront,
  "International rail": TrainFront,
  Tram: TramFront,
  Coach: Bus,
  Cycling: Bike,
  "Ferry (Foot passenger)": Ship,
  "Ferry (Car passenger)": Ship,

  Laptop,
  "Mobile phone charger": BatteryCharging,
  "Chargers for battery operated devices": BatteryCharging,
  "Battery chargers for tools": BatteryCharging,
  "Fridge (under counter type)": Refrigerator,
  Freezer: Snowflake,
  "Mini Fridge": Refrigerator,
  "Fridge Freezer (Standard)": Refrigerator,
  "American Style Fridge Freezer": Refrigerator,
  "Satellite TV box/ Streaming devices": Antenna,
  Printer,
  Radio: BoomBox,
  "Radiator or Fan Heater": Heater,
  "Desk lamp (with 60 W lamp)": LampDesk,
  "Desk lamp (with LED lamp)": LampDesk,
  "DVD/Blu-Ray player": Disc,
  "Landline cordless telephone charger": BatteryCharging,
  "Computer monitor": Monitor,
  "Desktop computer": PcCase,
  'Television 55” UHD': Tv,
  "Games console": Gamepad2,
  "Washing machine": WashingMachine,
  "Tumble dryer (condenser or vented)": WashingMachine,
  "Tumble dryer (Heat Pump)": AirVent,
  Microwave,
  "Wi-Fi router": Wifi,
  "Electric Vehicle (Slow Charge)": EvCharger,
  "Portable air conditioner": AirVent,
  "Patio Heater": Heater,
  "Alarm clock radio": BoomBox,
  "Slow cooker": CookingPot,
  "Portable Speaker (Bluetooth/wi-fi)": Speaker,
  "Dehumidifier (compressor type)": AirVent,
  "Dehumidifier (desiccant type)": AirVent,
};
